import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=5266c5d6&scoped=true&"
import script from "./LoginForm.vue?vue&type=script&lang=js&"
export * from "./LoginForm.vue?vue&type=script&lang=js&"
import style0 from "./LoginForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LoginForm.vue?vue&type=style&index=1&id=5266c5d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5266c5d6",
  null
  
)

export default component.exports